<div style="background: #ffeeff" class="h-100 overflow-auto">
  <app-sidebar-header title="{{ 'integration_of_Nova_Poshta' | translate }}"></app-sidebar-header>
  <mat-card style="" class="shadow-none bg-transparent">
    <mat-card-header class="d-flex flex-column bg-white rounded-2 m-3 p-4">
      <div class="d-flex flex-column bg-white rounded-2">
        <div class="d-flex flex-wrap gap-4">
          <div class="icon-logo"><img src="/assets/svgs/integrations/nova_poshta.svg" alt="Nova Delivery logo" /></div>
          <div>
            <h5>{{ 'add_API_Key' | translate }}</h5>
            <p>{{ 'you_can_delete_at_any_time' | translate }}</p>
            @if (dataSource$ | async; as ds) {
              <div class="d-flex gap-2 flex-wrap" [formGroup]="form">
                <app-text-field
                  placeholder="{{ 'name office' | translate }}"
                  [formControl]="form.controls.title"
                  customClass="h-36"
                ></app-text-field>
                <app-text-field
                  placeholder="API KEY"
                  (keydown.enter)="submit()"
                  [formControl]="form.controls.api_key"
                  customClass="h-36"
                ></app-text-field>
                <app-button (onChangeClick)="submit()" [disabled]="!form.controls.api_key.value">{{
                  'add' | translate
                }}</app-button>
              </div>
            }
          </div>
        </div>
      </div>
    </mat-card-header>
    @if (true) {
      <mat-card-content class="m-3 p-4 bg-white rounded-2">
        <h5>{{ 'connection_instructions_a_api_key' }}:</h5>
        <div>
          <div>1. {{ 'go_to_the_settings_and_select_the_section' | translate }} "{{ 'security' | translate }}".</div>
          <div>2. {{ 'click_the_button' | translate }} "{{ 'create_key' | translate }}".</div>
          <div>
            3. {{ 'you_will_be_provided_with_a_new_API_key' | translate }}.
            {{ 'enter_it_in_the_field_above_and_click_add' | translate }}.
          </div>
          <div>
            {{ 'the_site_is_available_at_this_link' | translate }}:
            <a href="https://new.novaposhta.ua/dashboard/settings/developers" target="_blank">{{
              'nova_poshta' | translate
            }}</a>
          </div>
        </div>
      </mat-card-content>
    }
    <mat-card-footer class="bg-white rounded-2 m-3 p-4">
      <h5>{{ 'API_key_settings' | translate }}</h5>
      <mat-divider></mat-divider>
      <div>
        <div class="d-flex gap-4 align-items-end flex-wrap">
          @if (dataSource$ | async; as dataSource) {
            <app-table
              class="w-100"
              [dataSource]="dataSource"
              [visibleColumnKeys]="visibleColumns"
              (onSortChange)="onSortChange($event)"
              (onPaginationChange)="onPaginationChange($event)"
              (menuSelected)="onActionChange($event)"
              (onTableRowClick)="onRowClick($event.row)"
            ></app-table>
          }
        </div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>

<!--<div>-->
<!--  <div class="d-flex gap-2">-->
<!--    <app-phone-field-->
<!--      [inputValue]="phoneInput"-->
<!--      (valueChanged)="phoneInput = $event"-->
<!--    ></app-phone-field>-->
<!--    <app-button (onChangeClick)="addPhone()" [disabled]="!phoneInput">Додати</app-button>-->
<!--  </div>-->
<!--  <div>-->
<!--    <app-table-->
<!--      *ngIf="dataSource$ | async as dataSource"-->
<!--      [dataSource]="dataSource"-->
<!--      [visibleColumnKeys]="visibleColumns"-->
<!--      (onSortChange)="onSortChange($event)"-->
<!--      (onPaginationChange)="onPaginationChange($event)"-->
<!--      (menuSelected)="onActionChange($event)"-->
<!--    ></app-table>-->
<!--  </div>-->
<!--</div>-->
